import React from 'react';
import Layout from './Layout';
import { motion } from 'framer-motion';
import image1 from '../assets/portfolio/Business Partner.png';
import image2 from '../assets/portfolio/Business Partner Graphic.png';
import image3 from '../assets/portfolio/Business Partner Graphic 2.png';

// Animation configurations
const animations = {
  container: {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true },
    transition: { duration: 5, ease: "easeInOut" } // Shorter duration for a smoother fade-in
  },
  header: {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeOut" } // Faster and more natural easing
  },
  contentLeft: {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeInOut" } // Smooth slide-in effect
  },
  contentRight: {
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeInOut" } // Smooth slide-in effect
  },
  image: (id) => ({
    initial: { opacity: 0, scale: 0.9 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true },
    transition: { duration: 1.5, delay: id * 0.2, ease: "easeOut" } // Subtle scaling with staggered delay
  }),
  button: {
    whileHover: { 
      scale: 1.1,
      backgroundColor: "#f3f4f6", // Slightly lighter hover effect
      transition: { duration: 0.3, ease: "easeInOut" } // Smooth hover transition
    }
  }
};

const BusinessPartner = () => {
  const sections = [
    {
      id: 1,
      title: "What Is a Business Partner?",
      text: "A Business Partner is a strategic advisor who collaborates with management to align financial strategies with organizational objectives. Through data-driven insights, I support decisions on strategic initiatives, market expansions, and portfolio optimization, ensuring the company's financial plans drive long-term success and sustainable growth.",
      image: image1,
      imageRight: true
    },
    {
      id: 2,
      title: "How Does Business Partnering Add Value?",
      text: "Business partnering adds value by bridging the gap between strategy and execution, offering data-driven insights, and fostering collaboration across teams. Whether the organization is pursuing mergers and acquisitions, implementing organizational changes, or facing growth challenges, I help navigate complexities and drive sustainable results through financial expertise and strategic guidance.",
      image: image2,
      imageRight: false
    },
    {
      id: 3,
      title: "Connect with Me",
      text: 'Business partnering bridges the gap between strategy and execution by offering tailored financial guidance. Whether your organization is launching new initiatives, expanding into new markets, or navigating industry changes, I foster collaboration across teams to deliver sustainable results and maximize business impact. \n\nCurrently I am working my hardest to ensure the succes of DB Cargo. Therefor I am not looking for new opportunities. However, I am always interested in getting better as a business partner. If you wanna chat about business partnering, you can reach me at villingerbl@gmail.com',
      image: image3,
      imageRight: true
    }
  ];

  return (
    <div>
      <Layout />
      <motion.div 
        {...animations.container}
        className="w-full min-h-screen bg-gradient-to-b from-white to-white text-black pt-20"
      >
        <div className="max-w-screen-lg mx-auto p-4">
          <motion.div 
            {...animations.header}
            className="mb-16 text-center"
          >
            <h1 className="text-4xl font-bold inline border-b-4 border-black">Business Partner</h1>
            <p className="mt-6 text-lg max-w-2xl mx-auto">
              Collaborative support for operational projects and strategic initiatives.
            </p>
          </motion.div>
          
          <div className="space-y-20">
            {sections.map(({ id, title, text, image, imageRight }) => (
                          <motion.div 
                            key={id}
                            className={`flex flex-col md:flex-row items-center gap-8 ${
                              imageRight ? '' : 'md:flex-row-reverse'
                            }`}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.2, delay: id * 0.5 }} // Staggered delay based on id
                          >
                            {/* Text Section */}
                            <motion.div
                              className="flex-1"
                            > 
                              <h2 className="text-2xl font-bold mb-4">{title}</h2>
                              <p className="text-lg whitespace-pre-wrap">{text}</p>
                              {id === 3 && (
                                <motion.button
                                  className="mt-6 px-5 py-2 bg-gray-100 rounded-md text-black font-medium"
                                  {...animations.button}
                                  onClick={() => window.location.href = "mailto:Villingerbl@gmail.com"}
                                >
                                  Contact Me
                                </motion.button>
                              )}
                            </motion.div>

                {/* Image Section */}
                <motion.div
                  className="flex-1"
                  {...animations.image(id)}
                >
                  <img 
                    src={image} 
                    alt={title} 
                    className="rounded-lg w-full h-auto shadow-md"
                  />
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessPartner;